/* ============================================================
   CamisFutbol · Mundial — theme.js  (vanilla, sin dependencias)
   ============================================================ */
(function(){
  'use strict';
  var $  = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var money = function(cents){ if(cents===0){return 'GRATIS';} return (cents/100).toFixed(2).replace('.',',')+' €'; };

  /* ---------- Barra de anuncios rotativa ---------- */
  function announcements(){
    var msgs = $$('.ann__msg'); if(msgs.length<2) return;
    var i=0; setInterval(function(){
      msgs[i].classList.remove('is-on');
      i=(i+1)%msgs.length;
      msgs[i].classList.add('is-on');
    },4500);
  }

  /* ---------- Drawers (menú + carrito) ---------- */
  function toggle(el,open){
    if(!el) return;
    el.classList.toggle('is-open', open);
    var back = el.classList.contains('drawer') ? $('#drawer-back')
             : el.classList.contains('cart-drawer') ? $('#cart-back') : null;
    if(back) back.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  function drawers(){
    var menu = $('#menu-drawer'), cart = $('#cart-drawer');
    $$('[data-open-menu]').forEach(function(b){b.addEventListener('click',function(){toggle(menu,true);});});
    $$('[data-open-cart]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();toggle(cart,true);refreshCart();});});
    $$('[data-close]').forEach(function(b){b.addEventListener('click',function(){toggle(menu,false);toggle(cart,false);});});
    var mb=$('#drawer-back'), cb=$('#cart-back');
    if(mb) mb.addEventListener('click',function(){toggle(menu,false);});
    if(cb) cb.addEventListener('click',function(){toggle(cart,false);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){toggle(menu,false);toggle(cart,false);}});
  }

  /* ---------- Carrito AJAX ---------- */
  function setCount(n){
    $$('.cart-count').forEach(function(el){el.textContent=n;el.setAttribute('data-empty', n>0?'false':'true');});
  }
  /* Banner de envío gratis de la ficha de producto: avanza con el carrito */
  // ¿Está el carrito a una sola camiseta del envío gratis? (2+ prendas dentro
  // y con una más de precio medio se pasa del umbral). Se usa para cambiar el
  // mensaje de euros por uno mucho más claro: "con tu 3ª camiseta".
  function oneAway(cart,left){
    var n=(cart&&cart.item_count)||0;
    if(n<2 || left<=0) return false;
    var avg=(cart.total_price||0)/n;
    return left<=avg*1.05;
  }
  function shipBanner(cart){
    var el=$('[data-shipbar]'); if(!el) return;
    var thr=parseInt(el.getAttribute('data-threshold'),10)||0; if(thr<=0) return;
    var total=(cart&&cart.total_price)||0;
    var n=(cart&&cart.item_count)||0;
    var left=thr-total;
    var pct=Math.max(0,Math.min(100,Math.round(total/thr*100)));
    var fill=$('[data-shipbar-fill]',el), pill=$('[data-shipbar-pill]',el), sub=$('[data-shipbar-sub]',el);
    var close=oneAway(cart,left);
    if(fill) fill.style.width=(close?Math.max(pct,88):pct)+'%';
    el.classList.toggle('is-full', left<=0 && total>0);
    el.classList.toggle('is-close', close);
    if(left<=0 && total>0){
      if(pill){ pill.hidden=false; pill.textContent='✓ GRATIS'; }
      if(sub) sub.innerHTML='<p>🎉 Ya tienes el <b>envío GRATIS</b> en este pedido.</p>';
    } else if(close){
      var more='/collections/camisetas-futbol-baratas';
      if(pill){ pill.hidden=false; pill.innerHTML='<a href="'+more+'">¡solo 1 más!</a>'; }
      if(sub) sub.innerHTML='<p>Llevas '+n+' camisetas. <a href="'+more+'"><b>Añade una más</b></a> y el envío te sale <b>GRATIS</b>.</p>';
    } else if(total>0){
      if(pill){ pill.hidden=false; pill.textContent='−'+money(left); }
      if(sub) sub.innerHTML='<p>Te faltan <b>'+money(left)+'</b> para el <b>envío GRATIS</b>.</p>';
    } else {
      if(pill) pill.hidden=true;
    }
  }

  function renderCart(cart){
    shipBanner(cart);
    var box=$('#cart-items'); if(!box) return;
    setCount(cart.item_count);
    var foot=$('#cart-foot'), bar=$('#cart-bar');
    if(cart.item_count===0){
      box.innerHTML='<div class="cart-empty"><p>Tu carrito está vacío.</p><a class="btn btn--ghost btn--sm" href="/collections/mundial-2026" data-close style="margin-top:14px">Ver camisetas del Mundial</a></div>';
      if(foot) foot.style.display='none';
      if(bar) bar.style.display='none';
      return;
    }
    if(foot) foot.style.display='';
    var html='';
    cart.items.forEach(function(it){
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url : '';
      var opt = it.variant_title && it.variant_title!=='Default Title' ? it.variant_title : '';
      var props='';
      if(it.properties){
        Object.keys(it.properties).forEach(function(k){
          if(k.charAt(0)==='_') return;
          var val=it.properties[k];
          if(val===null||val==='') return;
          props+='<div class="cart-line__prop">'+k+': '+val+'</div>';
        });
      }
      html+='<div class="cart-line" data-key="'+it.key+'">'+
        '<a href="'+it.url+'" data-close>'+(img?'<img src="'+img+'" alt="" loading="lazy">':'<div class="satc__img"></div>')+'</a>'+
        '<div><a href="'+it.url+'" data-close class="cart-line__title">'+it.product_title+'</a>'+
        (opt?'<div class="cart-line__opt">Talla: '+opt+'</div>':'')+
        props+
        '<div class="qty"><button data-dec aria-label="Quitar uno">−</button><span>'+it.quantity+'</span><button data-inc aria-label="Añadir uno">+</button></div></div>'+
        '<div class="cart-line__price">'+money(it.final_line_price)+'</div></div>';
    });
    box.innerHTML=html;
    if(foot){ $('#cart-subtotal').textContent=money(cart.total_price); }
    // Barra de progreso al bundle (configurable)
    if(bar){
      var thr = parseInt(bar.getAttribute('data-threshold'),10)||0; // céntimos
      if(thr>0){
        bar.style.display='';
        var pct=Math.min(100, Math.round(cart.total_price/thr*100));
        var fill=$('#cart-bar-fill');
        fill.style.width=pct+'%';
        var left=thr-cart.total_price;
        var close=oneAway(cart,left);
        fill.classList.toggle('is-full', left<=0);
        bar.classList.toggle('is-close', close);
        if(close) fill.style.width=Math.max(pct,88)+'%';
        var head=$('.cart-bar__headline span',bar);
        if(head) head.textContent = close ? '¡Solo te falta 1 camiseta!' : 'Con tu 3ª camiseta, ENVÍO GRATIS';
        $('#cart-bar-text').innerHTML = left<=0
          ? '🎉 ¡ENVÍO GRATIS conseguido!'
          : (close
              ? 'Añade <b>1 camiseta más</b> y el <b>envío es GRATIS</b> 🔥'
              : 'Te faltan <b>'+money(left)+'</b> para tu <b>envío GRATIS</b> 🚚');
      }
    }
    bindLines();
  }
  function bindLines(){
    $$('#cart-items .cart-line').forEach(function(line){
      var key=line.getAttribute('data-key');
      var span=$('.qty span',line);
      var q=parseInt(span.textContent,10);
      var inc=$('[data-inc]',line), dec=$('[data-dec]',line);
      if(inc) inc.addEventListener('click',function(){changeQty(key,q+1);});
      if(dec) dec.addEventListener('click',function(){changeQty(key,q-1);});
    });
  }
  function refreshCart(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  function changeQty(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:Math.max(0,qty)})})
      .then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  function addToCart(form,then){
    var btn=$('[name="add"]',form); var label=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.innerHTML='Añadiendo…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json();})
      .then(function(){ if(btn){btn.disabled=false;btn.innerHTML=label;} toggle($('#cart-drawer'),true); refreshCart(); if(then)then(); })
      .catch(function(){ if(btn){btn.disabled=false;btn.innerHTML=label;} form.submit(); });
  }
  function bindCartForms(scope){
    $$('form[data-cart-form]', scope || document).forEach(function(f){
      if(f.getAttribute('data-bound')) return;
      f.setAttribute('data-bound','1');
      f.addEventListener('submit',function(e){e.preventDefault();addToCart(f);});
    });
  }
  function cartForms(){
    refreshCart();
    bindCartForms(document); // botones "añadir" en tarjetas de producto
  }

  /* ---------- PDP: variantes / tallas ---------- */
  function productForm(){
    var root=$('#product-form'); if(!root) return;
    var data=$('#variant-data'); if(!data) return;
    var variants=[]; try{variants=JSON.parse(data.textContent);}catch(e){return;}
    var hidden=$('input[name="id"]',root);
    var priceEl=$('#pdp-price-now'), cmpEl=$('#pdp-price-cmp'), addBtn=$('[name="add"]',root);

    // Detecta los grupos de opciones (radios name="opt1","opt2"…)
    function optionGroups(){
      var groups=[], i=1;
      while($$('input[name="opt'+i+'"]',root).length){ groups.push('opt'+i); i++; }
      return groups;
    }
    var groups=optionGroups();
    function selectedValues(){
      return groups.map(function(g){ var c=root.querySelector('input[name="'+g+'"]:checked'); return c?c.value:null; });
    }
    function allChosen(){ return groups.length===0 || selectedValues().every(function(v){return v!=null;}); }
    function findVariant(){
      if(groups.length===0) return variants[0]; // producto sin opciones
      var sel=selectedValues();
      if(sel.some(function(v){return v==null;})) return null;
      return variants.filter(function(v){
        var opts=v.options||[v.option1,v.option2,v.option3];
        return sel.every(function(val,idx){ return opts[idx]===val; });
      })[0];
    }
    function update(){
      var v=findVariant();
      if(!v){ if(addBtn){addBtn.disabled=false;} return; }
      hidden.value=v.id;
      if(priceEl) priceEl.textContent=money(v.price);
      if(cmpEl){ if(v.compare_at_price && v.compare_at_price>v.price){cmpEl.textContent=money(v.compare_at_price);cmpEl.style.display='';} else {cmpEl.style.display='none';} }
      var sold=!v.available;
      if(addBtn){ addBtn.disabled=sold; addBtn.innerHTML = sold ? 'Agotada' : 'Añadir al carrito'; }
      var sp=$('#satc-price'); if(sp) sp.textContent=money(v.price);
      var sb=$('#satc-add'); if(sb){ sb.disabled=sold; sb.textContent=sold?'Agotada':'Añadir'; }
    }
    // marcar checked visual + soldout (por primera opción)
    $$('.size',root).forEach(function(lab){
      var input=$('input',lab);
      var match=variants.filter(function(v){var o=v.options||[v.option1];return o.indexOf(input.value)>-1;})[0];
      if(match && !match.available) lab.classList.add('is-soldout');
      input.addEventListener('change',function(){
        var name=input.getAttribute('name');
        $$('.size',root).forEach(function(l){ var inp=$('input',l); if(inp && inp.getAttribute('name')===name) l.classList.remove('is-checked'); });
        lab.classList.add('is-checked');
        var hint=$('#size-hint'); if(hint) hint.style.display='none';
        update();
      });
      if(input.checked) lab.classList.add('is-checked');
    });
    update();

    // ----- Personalización nativa (nombre + dorsal + parche) -----
    var pName=$('#perso-name'), pNum=$('#perso-num'), pPatch=$('#perso-patch');
    if(pName) pName.addEventListener('input',function(){ pName.value=pName.value.toUpperCase(); });
    if(pNum) pNum.addEventListener('input',function(){ pNum.value=pNum.value.replace(/\D/g,''); });
    if(pPatch){
      // "Sin parche" (value vacío) no viaja con el pedido; con parche, resalta el campo
      var syncPatch=function(){
        var on = pPatch.value !== '';
        pPatch.classList.toggle('is-set', on);
        if(on){ pPatch.setAttribute('name','properties[Parche]'); }
        else { pPatch.removeAttribute('name'); }
      };
      pPatch.addEventListener('change', syncPatch);
      syncPatch();
    }

    root.addEventListener('submit',function(e){e.preventDefault();
      if(!allChosen()){
        var hint=$('#size-hint'); if(hint){hint.style.display='block';hint.scrollIntoView({behavior:'smooth',block:'center'});}
        return;
      }
      addToCart(root);
    });
    // botón sticky comparte el form
    var sAdd=$('#satc-add');
    if(sAdd) sAdd.addEventListener('click',function(){ root.requestSubmit ? root.requestSubmit() : root.dispatchEvent(new Event('submit',{cancelable:true})); });
  }

  /* ---------- "Completa tu compra": mismo equipo + misma temporada ---------- */
  function upsell(){
    var box=$('[data-upsell]'); if(!box) return;
    var out=$('[data-upsell-grid]',box); if(!out) return;
    var title=box.getAttribute('data-product-title')||'';
    var handle=box.getAttribute('data-product-handle')||'';
    var pid=box.getAttribute('data-product-id')||'';
    var limit=parseInt(box.getAttribute('data-limit'),10)||4;

    /* ---- Claves del producto actual ---- */

    // Modelo: sin la versión entre paréntesis (Fan / Player / Niño / Mujer /
    // Bebé) ni los añadidos de confección. Así un modelo sale UNA vez.
    function modelKey(t){
      return (t||'').toLowerCase()
        .split('(')[0]
        .replace(/manga larga/g,'')
        .replace(/todos los patrocinadores/g,'')
        .replace(/[^0-9a-záéíóúüñ]+/g,' ')
        .trim();
    }
    function norm(t){
      t=(t||'').toLowerCase();
      return t.normalize ? t.normalize('NFD').replace(/[̀-ͯ]/g,'') : t;
    }
    // Equipo: todo lo anterior a la temporada, sin acentos ni ruido.
    // "Retro Real Madrid 17-18 Visitante (Manga Larga)" -> "real madrid"
    function teamKey(t){
      var s=norm(t).replace(/[^0-9a-z]+/g,' ');
      var mm=s.match(/(\d{2}\s?\d{2}|(?:18|19|20)\d{2})/);
      if(mm) s=s.slice(0,mm.index);
      s=s.replace(/\b(retro|camiseta|camisetas|pantalon|pantalones|short|shorts|body|conjunto|chandal|sudadera|chaqueta|kit|equipacion|de|del|la|el)\b/g,' ').replace(/\s+/g,' ').trim();
      return s;
    }
    function sameTeam(a,b){
      if(!a||!b) return false;
      if(a===b) return true;
      return (a+' ').indexOf(b+' ')===0 || (b+' ').indexOf(a+' ')===0;
    }
    // Prenda: pantalón, crop top de mujer, body de bebé, versión niño…
    function kindOf(t){
      var s=norm(t);
      if(/pantalon|shorts?\b/.test(s)) return 'pantalon';
      if(/crop\s*top|\bcrop\b|\bmujer\b|\bfemenin/.test(s)) return 'mujer';
      if(/\bbebe\b|\bbody\b/.test(s)) return 'bebe';
      if(/\bnino\b|\bninos\b|\bkids?\b/.test(s)) return 'nino';
      return 'camiseta';
    }
    // Equipación (local / visitante / tercera…) y temporada normalizada
    // ("26-27" y "26/27" -> "2627"; "2026" -> "2026").
    function kitOf(t){
      var m=norm(t).match(/\b(local|visitante|tercera|cuarta|portero|entrenamiento|prepartido)\b/);
      return m?m[1]:'';
    }
    function seasonOf(t){
      var s=norm(t).replace(/[^0-9a-z]+/g,' ');
      var m=s.match(/(\d{2}\s?\d{2}|(?:18|19|20)\d{2})/);
      return m?m[0].replace(/\s/g,''):'';
    }

    var curKey=modelKey(title);
    var curKind=kindOf(title), curKit=kitOf(title), curSeason=seasonOf(title);
    var m=title.match(/(\d{2}\s?[-\/]\s?\d{2}|(?:18|19|20)\d{2})/);
    var season=m?m[0].replace(/\s/g,''):'';
    var rawTeam=m?title.slice(0,m.index).replace(/[\s\-–—·|]+$/,'').trim():'';
    // Para comparar, la clave normalizada; para buscar y para el rótulo, el
    // nombre con acentos que pinta el servidor ("España", "Atlético Madrid").
    var teamQ=(box.getAttribute('data-team')||'').trim()||rawTeam;
    var curTeam=norm(teamQ).replace(/[^0-9a-z]+/g,' ').trim()||teamKey(title);

    // Prioridad de complementos del MISMO modelo.
    var WANT=['mujer','bebe','pantalon'];
    if(curKind!=='camiseta') WANT=['camiseta'].concat(WANT);
    WANT=WANT.filter(function(k){ return k!==curKind; });

    /* ---- Utilidades ---- */

    function get(url,cb){
      fetch(url,{headers:{'Accept':'text/html'}})
        .then(function(r){ return r.ok ? r.text() : ''; })
        .then(function(html){ cb(html||''); })
        .catch(function(){ cb(''); });
    }
    // Pide el trozo de sección (ligero); si el tema publicado no la tiene,
    // reintenta con la página completa, que trae las mismas tarjetas.
    function getCards(url,cb){
      var sep=url.indexOf('?')>-1?'&':'?';
      get(url+sep+'section_id=completa-tu-compra',function(html){
        if(html && html.indexOf('card__title')>-1){ cb(html); return; }
        get(url,cb);
      });
    }
    function search(q,cb){
      getCards('/search?type=product&options[prefix]=last&q='+encodeURIComponent(q),cb);
    }
    function nodes(html){
      if(!html) return [];
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      var grid=tmp.querySelector('[data-upsell-grid]')||tmp;
      return $$('.card',grid);
    }
    function titleOf(c){ return (c.querySelector('.card__title')||{}).textContent||''; }
    function hrefOf(c){
      var a=c.querySelector('a[href*="/products/"]');
      return a?a.getAttribute('href').split('?')[0]:'';
    }
    function isSelf(c){ return hrefOf(c).indexOf('/products/'+handle)>-1; }

    // Camisetas del mismo equipo, un modelo por tarjeta (gana "Fan Version").
    // loose=true salta el filtro de equipo (solo para el rescate final).
    function pick(list,loose){
      var keys=[], picked=[];
      list.forEach(function(c){
        if(isSelf(c)) return;
        var t=titleOf(c), k=modelKey(t);
        if(!k || k===curKey) return;
        if(!loose && curTeam && !sameTeam(teamKey(t),curTeam)) return;
        var i=keys.indexOf(k);
        if(i===-1){ keys.push(k); picked.push(c); return; }
        if(/fan version/i.test(t) && !/fan version/i.test(titleOf(picked[i]))) picked[i]=c;
      });
      return picked;
    }
    // Complementos del MISMO modelo: mismo equipo y temporada. Se prefiere la
    // misma equipación; si no la hay, vale otra del mismo equipo y temporada.
    function complements(list){
      var exact={}, near={};
      list.forEach(function(c){
        if(isSelf(c)) return;
        var t=titleOf(c);
        if(curTeam && !sameTeam(teamKey(t),curTeam)) return;
        if(curSeason && seasonOf(t)!==curSeason) return;
        var k=kindOf(t);
        if(WANT.indexOf(k)===-1) return;
        if(curKit && kitOf(t) && kitOf(t)!==curKit){ if(!near[k]) near[k]=c; return; }
        if(!exact[k]) exact[k]=c;
      });
      return WANT.map(function(k){ return exact[k]||near[k]; }).filter(Boolean);
    }
    function merge(){
      var seenHref=[], res=[];
      [].slice.call(arguments).forEach(function(list){
        (list||[]).forEach(function(c){
          var h=hrefOf(c);
          if(!h || seenHref.indexOf(h)>-1) return;
          seenHref.push(h); res.push(c);
        });
      });
      return res;
    }
    function paint(cards){
      if(!cards.length) return false;
      box.classList.remove('is-loading');
      out.innerHTML='';
      cards.slice(0,limit).forEach(function(c){ out.appendChild(c); });
      bindCartForms(out);
      return true;
    }
    // Nunca se queda vacío: si nada de lo anterior dio resultado, vuelve el
    // relleno del servidor; solo se oculta si tampoco había nada.
    function prune(){
      box.classList.remove('is-loading');
      if($$('.card',out).length<1 && backup){ out.innerHTML=backup; bindCartForms(out); }
      if($$('.card',out).length<1) box.setAttribute('hidden','');
    }

    /* ---- Cascada de recomendación ----
       1. mismo modelo: crop top de mujer, body de bebé, pantalón
       2. mismo equipo y misma temporada
       3. mismo equipo, cualquier temporada
       4. recomendaciones de Shopify del mismo equipo
       5. lo más vendido del último mes (ya de otros equipos)
       El bloque nunca se queda vacío.                                    */

    // Lo que ya pintó el servidor sirve de base. Si viene marcado como relleno
    // genérico (otros equipos), se vacía mientras se busca lo correcto y se
    // guarda por si al final no hubiera nada mejor que enseñar.
    var generic=out.hasAttribute('data-generic');
    var backup=out.innerHTML;
    var base=generic?[]:$$('.card',out);
    var baseExtra=complements(base), baseSame=pick(base);
    if(generic){ out.innerHTML=''; box.classList.add('is-loading'); }

    function done(extra,same){
      var cards=merge(extra,same);
      if(cards.length<2) return false;
      return paint(cards);
    }

    if(rawTeam.length>1 && season){
      search(teamQ+' '+season, function(html){
        var list=nodes(html);
        var extra=merge(baseExtra,complements(list));
        var same=merge(baseSame,pick(list));
        // ¿Faltan complementos? Una búsqueda dirigida los saca a flote.
        if(extra.length<WANT.length){
          search(teamQ+' '+season+' pantalón mujer bebé', function(html2){
            var list2=nodes(html2);
            extra=merge(extra,complements(list2));
            same=merge(same,pick(list2));
            if(!done(extra,same)) anySeason(extra);
          });
          return;
        }
        if(!done(extra,same)) anySeason(extra);
      });
    } else {
      anySeason([]);
    }

    // 3) Mismo equipo, cualquier temporada
    function anySeason(extra){
      if(!teamQ){ recommend(); return; }
      search(teamQ, function(html){
        var list=nodes(html);
        var ex=merge(extra,baseExtra);
        var same=merge(baseSame,pick(list));
        if(!done(ex,same)) recommend();
      });
    }
    // 4) Recomendaciones de Shopify, filtradas al mismo equipo
    function recommend(){
      if(!pid){ bestSellers(''); return; }
      get('/recommendations/products?product_id='+pid+'&limit=12&intent=related&section_id=completa-tu-compra',
        function(html){
          var cards=merge(baseExtra,baseSame,pick(nodes(html)));
          if(cards.length>=2){
            paint(cards);
            return;
          }
          bestSellers(html);
        });
    }
    // 5) Lo más vendido del último mes (Shopify ordena por ventas recientes)
    function bestSellers(recHtml){
      getCards('/collections/all?sort_by=best-selling', function(html){
        var cards=pick(nodes(html),true);
        if(cards.length>=2){
          paint(cards);
          return;
        }
        var loose=pick(nodes(recHtml),true);
        if(loose.length>=2){
          paint(loose);
          return;
        }
        prune();
      });
    }
  }

  /* ---------- Galería PDP ---------- */
  function gallery(){
    var main=$('#gal-main-img'); if(!main) return;
    $$('.gal__thumb').forEach(function(t){
      t.addEventListener('click',function(){
        $$('.gal__thumb').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
        main.src=t.getAttribute('data-full');
      });
    });
  }

  /* ---------- Sticky ATC visibilidad ---------- */
  function stickyAtc(){
    var bar=$('#satc'), anchor=$('#buy-anchor'); if(!bar||!anchor) return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top<0); });
    },{threshold:0});
    io.observe(anchor);
  }

  /* ---------- Acordeones (mejora) y modal guía tallas ---------- */
  function modals(){
    var open=function(id){var m=$(id);if(m){m.classList.add('is-open');document.documentElement.style.overflow='hidden';}};
    var close=function(m){m.classList.remove('is-open');document.documentElement.style.overflow='';};
    $$('[data-open-size]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();open('#size-modal');});});
    $$('.modal-back').forEach(function(m){
      m.addEventListener('click',function(e){if(e.target===m)close(m);});
      $$('[data-close-modal]',m).forEach(function(b){b.addEventListener('click',function(){close(m);});});
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')$$('.modal-back.is-open').forEach(close);});
  }

  /* ---------- Popup descuento ---------- */
  function popup(){
    var p=$('#promo-popup'); if(!p) return;
    var KEY='cf_popup_v1';
    var days=parseInt(p.getAttribute('data-days'),10)||7;
    var delay=parseInt(p.getAttribute('data-delay'),10)||7;
    function seen(){ try{var t=localStorage.getItem(KEY);return t && (Date.now()-parseInt(t,10))<days*864e5;}catch(e){return false;} }
    function mark(){ try{localStorage.setItem(KEY,String(Date.now()));}catch(e){} }
    function show(){ if(seen()||p.classList.contains('is-open'))return; p.classList.add('is-open'); mark(); }
    function hide(){ p.classList.remove('is-open'); }
    if(seen()) return;
    var t=setTimeout(show, delay*1000);
    // exit-intent (solo desktop)
    if(window.matchMedia('(min-width:900px)').matches){
      document.addEventListener('mouseout',function(e){ if(e.clientY<=0){show();} });
    }
    $$('[data-close-popup]',p).forEach(function(b){b.addEventListener('click',hide);});
    p.addEventListener('click',function(e){if(e.target===p)hide();});
    // al enviar: captura el email (fetch, sin recargar) y revela el código
    var form=$('#popup-form',p);
    if(form) form.addEventListener('submit',function(e){
      e.preventDefault();
      var reveal=function(){ var s=$('#popup-success'),m=$('#popup-main'); if(s&&m){m.style.display='none';s.style.display='block';} };
      try{
        fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'text/html'}})
          .then(reveal).catch(reveal);
      }catch(err){ reveal(); }
    });
  }

  /* ---------- Consentimiento de cookies + píxeles ---------- */
  function consent(){
    var c=$('#cookie'); if(!c) return;
    var KEY='cf_consent_v1';
    var saved=null; try{saved=localStorage.getItem(KEY);}catch(e){}
    if(!saved){ c.classList.add('is-on'); }
    else if(saved==='all'){ loadPixels(); }
    function set(val){ try{localStorage.setItem(KEY,val);}catch(e){} c.classList.remove('is-on'); if(val==='all')loadPixels(); }
    var a=$('[data-cookie-accept]',c), r=$('[data-cookie-reject]',c);
    if(a) a.addEventListener('click',function(){set('all');});
    if(r) r.addEventListener('click',function(){set('reject');});
  }
  function loadPixels(){
    if(window.__cfPixels) return; window.__cfPixels=true;
    var cfg=window.CF_PIXELS||{};
    // Meta Pixel
    if(cfg.meta){
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init',cfg.meta); fbq('track','PageView');
    }
    // TikTok Pixel
    if(cfg.tiktok){
      !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie'];
      ttq.setAndDefer=function(e,n){e[n]=function(){e.push([n].concat(Array.prototype.slice.call(arguments,0)))}};
      for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
      ttq.load=function(e){var n='https://analytics.tiktok.com/i18n/pixel/events.js';ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=n;ttq._t=ttq._t||{};ttq._t[e]=+new Date;
      var o=d.createElement('script');o.async=!0;o.src=n+'?sdkid='+e+'&lib='+t;var a=d.getElementsByTagName('script')[0];a.parentNode.insertBefore(o,a)};
      ttq.load(cfg.tiktok);ttq.page();}(window,document,'ttq');
    }
    // GA4 / Google Ads
    if(cfg.ga4 || cfg.gads){
      var id=cfg.ga4||cfg.gads;
      var g=document.createElement('script');g.async=true;g.src='https://www.googletagmanager.com/gtag/js?id='+id;
      document.head.appendChild(g);
      window.dataLayer=window.dataLayer||[];window.gtag=function(){dataLayer.push(arguments);};
      gtag('js',new Date());
      if(cfg.ga4) gtag('config',cfg.ga4);
      if(cfg.gads) gtag('config',cfg.gads);
    }
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded',function(){
    announcements(); drawers(); cartForms(); productForm(); gallery(); upsell();
    stickyAtc(); modals(); popup(); consent();
  });
})();
